module.exports = __webpack_public_path__ + "static/img/xwzx2x-BSkHWAXV.25ac1e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/xwzx2x-BSkHWAXV.png
// module id = +VpX
// module chunks = 16